import eventStreamSlice, { EventStreamSlice as _EventStreamSlice } from './eventStreamSlice'

export type EventStreamSlice = _EventStreamSlice
export const eventStreamReducer = eventStreamSlice.reducer
export const eventStreamActions = eventStreamSlice.actions
export default eventStreamSlice